// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: handoff.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "handoff";

export interface HandoffReferences {
  topics: { [key: string]: boolean };
  flowSteps: { [key: string]: boolean };
}

export interface HandoffReferences_TopicsEntry {
  key: string;
  value: boolean;
}

export interface HandoffReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface SipConfig {
  config: { $case: "invite"; value: SipInviteHandoffConfig } | { $case: "refer"; value: SipReferHandoffConfig } | {
    $case: "bye";
    value: SipByeHandoffConfig;
  } | undefined;
}

export interface SipInviteHandoffConfig {
  phoneNumber: string;
  outboundEndpoint: string;
  outboundEncryption: string;
}

export interface SipReferHandoffConfig {
  phoneNumber: string;
}

/** Empty config */
export interface SipByeHandoffConfig {
}

export interface SipHeaders {
  headers: SipHeader[];
}

export interface SipHeader {
  key: string;
  value: string;
}

/** persisted messages */
export interface Handoffs {
  handoffs: HandoffConfig[];
}

export interface HandoffConfig {
  id: string;
  name: string;
  createdBy: string;
  createdAt: Date | undefined;
  description: string;
  sipConfig: SipConfig | undefined;
  sipHeaders: SipHeaders | undefined;
  active: boolean;
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
  references: HandoffReferences | undefined;
  isDefault: boolean;
}

/** commands */
export interface HandoffCreate {
  id: string;
  name: string;
  description: string;
  sipConfig: SipConfig | undefined;
  sipHeaders: SipHeaders | undefined;
  active: boolean;
  references: HandoffReferences | undefined;
}

export interface HandoffUpdate {
  id: string;
  name?: string | undefined;
  description?: string | undefined;
  sipConfig?: SipConfig | undefined;
  sipHeaders?: SipHeaders | undefined;
  active?: boolean | undefined;
  references?: HandoffReferences | undefined;
}

export interface HandoffSetDefault {
  id: string;
}

export interface HandoffDelete {
  id: string;
}

export interface HandoffResetHandoffConfigs {
  sipConfig?: SipConfig | undefined;
  sipHeaders?: SipHeaders | undefined;
}

function createBaseHandoffReferences(): HandoffReferences {
  return { topics: {}, flowSteps: {} };
}

export const HandoffReferences: MessageFns<HandoffReferences> = {
  encode(message: HandoffReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.topics).forEach(([key, value]: [string, boolean]) => {
      HandoffReferences_TopicsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      HandoffReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = HandoffReferences_TopicsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.topics[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = HandoffReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.flowSteps[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffReferences {
    return {
      topics: isObject(object.topics)
        ? (globalThis.Object.entries(object.topics) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: HandoffReferences): unknown {
    const obj: any = {};
    if (message.topics) {
      const entries = globalThis.Object.entries(message.topics) as [string, boolean][];
      if (entries.length > 0) {
        obj.topics = {};
        entries.forEach(([k, v]) => {
          obj.topics[k] = v;
        });
      }
    }
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffReferences>): HandoffReferences {
    return HandoffReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffReferences>): HandoffReferences {
    const message = createBaseHandoffReferences();
    message.topics = (globalThis.Object.entries(object.topics ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseHandoffReferences_TopicsEntry(): HandoffReferences_TopicsEntry {
  return { key: "", value: false };
}

export const HandoffReferences_TopicsEntry: MessageFns<HandoffReferences_TopicsEntry> = {
  encode(message: HandoffReferences_TopicsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffReferences_TopicsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffReferences_TopicsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffReferences_TopicsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: HandoffReferences_TopicsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffReferences_TopicsEntry>): HandoffReferences_TopicsEntry {
    return HandoffReferences_TopicsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffReferences_TopicsEntry>): HandoffReferences_TopicsEntry {
    const message = createBaseHandoffReferences_TopicsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseHandoffReferences_FlowStepsEntry(): HandoffReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const HandoffReferences_FlowStepsEntry: MessageFns<HandoffReferences_FlowStepsEntry> = {
  encode(message: HandoffReferences_FlowStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: HandoffReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffReferences_FlowStepsEntry>): HandoffReferences_FlowStepsEntry {
    return HandoffReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffReferences_FlowStepsEntry>): HandoffReferences_FlowStepsEntry {
    const message = createBaseHandoffReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseSipConfig(): SipConfig {
  return { config: undefined };
}

export const SipConfig: MessageFns<SipConfig> = {
  encode(message: SipConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.config?.$case) {
      case "invite":
        SipInviteHandoffConfig.encode(message.config.value, writer.uint32(10).fork()).join();
        break;
      case "refer":
        SipReferHandoffConfig.encode(message.config.value, writer.uint32(18).fork()).join();
        break;
      case "bye":
        SipByeHandoffConfig.encode(message.config.value, writer.uint32(26).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SipConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSipConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = { $case: "invite", value: SipInviteHandoffConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.config = { $case: "refer", value: SipReferHandoffConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = { $case: "bye", value: SipByeHandoffConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SipConfig {
    return {
      config: isSet(object.invite)
        ? { $case: "invite", value: SipInviteHandoffConfig.fromJSON(object.invite) }
        : isSet(object.refer)
        ? { $case: "refer", value: SipReferHandoffConfig.fromJSON(object.refer) }
        : isSet(object.bye)
        ? { $case: "bye", value: SipByeHandoffConfig.fromJSON(object.bye) }
        : undefined,
    };
  },

  toJSON(message: SipConfig): unknown {
    const obj: any = {};
    if (message.config?.$case === "invite") {
      obj.invite = SipInviteHandoffConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "refer") {
      obj.refer = SipReferHandoffConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "bye") {
      obj.bye = SipByeHandoffConfig.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<SipConfig>): SipConfig {
    return SipConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SipConfig>): SipConfig {
    const message = createBaseSipConfig();
    switch (object.config?.$case) {
      case "invite": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "invite", value: SipInviteHandoffConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "refer": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "refer", value: SipReferHandoffConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "bye": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "bye", value: SipByeHandoffConfig.fromPartial(object.config.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseSipInviteHandoffConfig(): SipInviteHandoffConfig {
  return { phoneNumber: "", outboundEndpoint: "", outboundEncryption: "" };
}

export const SipInviteHandoffConfig: MessageFns<SipInviteHandoffConfig> = {
  encode(message: SipInviteHandoffConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.phoneNumber !== "") {
      writer.uint32(10).string(message.phoneNumber);
    }
    if (message.outboundEndpoint !== "") {
      writer.uint32(18).string(message.outboundEndpoint);
    }
    if (message.outboundEncryption !== "") {
      writer.uint32(26).string(message.outboundEncryption);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SipInviteHandoffConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSipInviteHandoffConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.outboundEndpoint = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.outboundEncryption = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SipInviteHandoffConfig {
    return {
      phoneNumber: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : "",
      outboundEndpoint: isSet(object.outboundEndpoint)
        ? globalThis.String(object.outboundEndpoint)
        : isSet(object.outbound_endpoint)
        ? globalThis.String(object.outbound_endpoint)
        : "",
      outboundEncryption: isSet(object.outboundEncryption)
        ? globalThis.String(object.outboundEncryption)
        : isSet(object.outbound_encryption)
        ? globalThis.String(object.outbound_encryption)
        : "",
    };
  },

  toJSON(message: SipInviteHandoffConfig): unknown {
    const obj: any = {};
    if (message.phoneNumber !== "") {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.outboundEndpoint !== "") {
      obj.outboundEndpoint = message.outboundEndpoint;
    }
    if (message.outboundEncryption !== "") {
      obj.outboundEncryption = message.outboundEncryption;
    }
    return obj;
  },

  create(base?: DeepPartial<SipInviteHandoffConfig>): SipInviteHandoffConfig {
    return SipInviteHandoffConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SipInviteHandoffConfig>): SipInviteHandoffConfig {
    const message = createBaseSipInviteHandoffConfig();
    message.phoneNumber = object.phoneNumber ?? "";
    message.outboundEndpoint = object.outboundEndpoint ?? "";
    message.outboundEncryption = object.outboundEncryption ?? "";
    return message;
  },
};

function createBaseSipReferHandoffConfig(): SipReferHandoffConfig {
  return { phoneNumber: "" };
}

export const SipReferHandoffConfig: MessageFns<SipReferHandoffConfig> = {
  encode(message: SipReferHandoffConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.phoneNumber !== "") {
      writer.uint32(10).string(message.phoneNumber);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SipReferHandoffConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSipReferHandoffConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SipReferHandoffConfig {
    return {
      phoneNumber: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : "",
    };
  },

  toJSON(message: SipReferHandoffConfig): unknown {
    const obj: any = {};
    if (message.phoneNumber !== "") {
      obj.phoneNumber = message.phoneNumber;
    }
    return obj;
  },

  create(base?: DeepPartial<SipReferHandoffConfig>): SipReferHandoffConfig {
    return SipReferHandoffConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SipReferHandoffConfig>): SipReferHandoffConfig {
    const message = createBaseSipReferHandoffConfig();
    message.phoneNumber = object.phoneNumber ?? "";
    return message;
  },
};

function createBaseSipByeHandoffConfig(): SipByeHandoffConfig {
  return {};
}

export const SipByeHandoffConfig: MessageFns<SipByeHandoffConfig> = {
  encode(_: SipByeHandoffConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SipByeHandoffConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSipByeHandoffConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SipByeHandoffConfig {
    return {};
  },

  toJSON(_: SipByeHandoffConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<SipByeHandoffConfig>): SipByeHandoffConfig {
    return SipByeHandoffConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<SipByeHandoffConfig>): SipByeHandoffConfig {
    const message = createBaseSipByeHandoffConfig();
    return message;
  },
};

function createBaseSipHeaders(): SipHeaders {
  return { headers: [] };
}

export const SipHeaders: MessageFns<SipHeaders> = {
  encode(message: SipHeaders, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.headers) {
      SipHeader.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SipHeaders {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSipHeaders();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.headers.push(SipHeader.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SipHeaders {
    return {
      headers: globalThis.Array.isArray(object?.headers) ? object.headers.map((e: any) => SipHeader.fromJSON(e)) : [],
    };
  },

  toJSON(message: SipHeaders): unknown {
    const obj: any = {};
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => SipHeader.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<SipHeaders>): SipHeaders {
    return SipHeaders.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SipHeaders>): SipHeaders {
    const message = createBaseSipHeaders();
    message.headers = object.headers?.map((e) => SipHeader.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSipHeader(): SipHeader {
  return { key: "", value: "" };
}

export const SipHeader: MessageFns<SipHeader> = {
  encode(message: SipHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SipHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSipHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SipHeader {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: SipHeader): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<SipHeader>): SipHeader {
    return SipHeader.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SipHeader>): SipHeader {
    const message = createBaseSipHeader();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseHandoffs(): Handoffs {
  return { handoffs: [] };
}

export const Handoffs: MessageFns<Handoffs> = {
  encode(message: Handoffs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.handoffs) {
      HandoffConfig.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Handoffs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.handoffs.push(HandoffConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Handoffs {
    return {
      handoffs: globalThis.Array.isArray(object?.handoffs)
        ? object.handoffs.map((e: any) => HandoffConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Handoffs): unknown {
    const obj: any = {};
    if (message.handoffs?.length) {
      obj.handoffs = message.handoffs.map((e) => HandoffConfig.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Handoffs>): Handoffs {
    return Handoffs.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Handoffs>): Handoffs {
    const message = createBaseHandoffs();
    message.handoffs = object.handoffs?.map((e) => HandoffConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHandoffConfig(): HandoffConfig {
  return {
    id: "",
    name: "",
    createdBy: "",
    createdAt: undefined,
    description: "",
    sipConfig: undefined,
    sipHeaders: undefined,
    active: false,
    updatedBy: undefined,
    updatedAt: undefined,
    references: undefined,
    isDefault: false,
  };
}

export const HandoffConfig: MessageFns<HandoffConfig> = {
  encode(message: HandoffConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.createdBy !== "") {
      writer.uint32(34).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.sipConfig !== undefined) {
      SipConfig.encode(message.sipConfig, writer.uint32(58).fork()).join();
    }
    if (message.sipHeaders !== undefined) {
      SipHeaders.encode(message.sipHeaders, writer.uint32(66).fork()).join();
    }
    if (message.active !== false) {
      writer.uint32(72).bool(message.active);
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(82).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(90).fork()).join();
    }
    if (message.references !== undefined) {
      HandoffReferences.encode(message.references, writer.uint32(98).fork()).join();
    }
    if (message.isDefault !== false) {
      writer.uint32(104).bool(message.isDefault);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sipConfig = SipConfig.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.sipHeaders = SipHeaders.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.references = HandoffReferences.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      sipConfig: isSet(object.sipConfig)
        ? SipConfig.fromJSON(object.sipConfig)
        : isSet(object.sip_config)
        ? SipConfig.fromJSON(object.sip_config)
        : undefined,
      sipHeaders: isSet(object.sipHeaders)
        ? SipHeaders.fromJSON(object.sipHeaders)
        : isSet(object.sip_headers)
        ? SipHeaders.fromJSON(object.sip_headers)
        : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      references: isSet(object.references) ? HandoffReferences.fromJSON(object.references) : undefined,
      isDefault: isSet(object.isDefault)
        ? globalThis.Boolean(object.isDefault)
        : isSet(object.is_default)
        ? globalThis.Boolean(object.is_default)
        : false,
    };
  },

  toJSON(message: HandoffConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.sipConfig !== undefined) {
      obj.sipConfig = SipConfig.toJSON(message.sipConfig);
    }
    if (message.sipHeaders !== undefined) {
      obj.sipHeaders = SipHeaders.toJSON(message.sipHeaders);
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.references !== undefined) {
      obj.references = HandoffReferences.toJSON(message.references);
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffConfig>): HandoffConfig {
    return HandoffConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffConfig>): HandoffConfig {
    const message = createBaseHandoffConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.description = object.description ?? "";
    message.sipConfig = (object.sipConfig !== undefined && object.sipConfig !== null)
      ? SipConfig.fromPartial(object.sipConfig)
      : undefined;
    message.sipHeaders = (object.sipHeaders !== undefined && object.sipHeaders !== null)
      ? SipHeaders.fromPartial(object.sipHeaders)
      : undefined;
    message.active = object.active ?? false;
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? HandoffReferences.fromPartial(object.references)
      : undefined;
    message.isDefault = object.isDefault ?? false;
    return message;
  },
};

function createBaseHandoffCreate(): HandoffCreate {
  return {
    id: "",
    name: "",
    description: "",
    sipConfig: undefined,
    sipHeaders: undefined,
    active: false,
    references: undefined,
  };
}

export const HandoffCreate: MessageFns<HandoffCreate> = {
  encode(message: HandoffCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.sipConfig !== undefined) {
      SipConfig.encode(message.sipConfig, writer.uint32(34).fork()).join();
    }
    if (message.sipHeaders !== undefined) {
      SipHeaders.encode(message.sipHeaders, writer.uint32(42).fork()).join();
    }
    if (message.active !== false) {
      writer.uint32(48).bool(message.active);
    }
    if (message.references !== undefined) {
      HandoffReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sipConfig = SipConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sipHeaders = SipHeaders.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = HandoffReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      sipConfig: isSet(object.sipConfig)
        ? SipConfig.fromJSON(object.sipConfig)
        : isSet(object.sip_config)
        ? SipConfig.fromJSON(object.sip_config)
        : undefined,
      sipHeaders: isSet(object.sipHeaders)
        ? SipHeaders.fromJSON(object.sipHeaders)
        : isSet(object.sip_headers)
        ? SipHeaders.fromJSON(object.sip_headers)
        : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      references: isSet(object.references) ? HandoffReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: HandoffCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.sipConfig !== undefined) {
      obj.sipConfig = SipConfig.toJSON(message.sipConfig);
    }
    if (message.sipHeaders !== undefined) {
      obj.sipHeaders = SipHeaders.toJSON(message.sipHeaders);
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.references !== undefined) {
      obj.references = HandoffReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffCreate>): HandoffCreate {
    return HandoffCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffCreate>): HandoffCreate {
    const message = createBaseHandoffCreate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.sipConfig = (object.sipConfig !== undefined && object.sipConfig !== null)
      ? SipConfig.fromPartial(object.sipConfig)
      : undefined;
    message.sipHeaders = (object.sipHeaders !== undefined && object.sipHeaders !== null)
      ? SipHeaders.fromPartial(object.sipHeaders)
      : undefined;
    message.active = object.active ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? HandoffReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseHandoffUpdate(): HandoffUpdate {
  return {
    id: "",
    name: undefined,
    description: undefined,
    sipConfig: undefined,
    sipHeaders: undefined,
    active: undefined,
    references: undefined,
  };
}

export const HandoffUpdate: MessageFns<HandoffUpdate> = {
  encode(message: HandoffUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.sipConfig !== undefined) {
      SipConfig.encode(message.sipConfig, writer.uint32(34).fork()).join();
    }
    if (message.sipHeaders !== undefined) {
      SipHeaders.encode(message.sipHeaders, writer.uint32(42).fork()).join();
    }
    if (message.active !== undefined) {
      writer.uint32(48).bool(message.active);
    }
    if (message.references !== undefined) {
      HandoffReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sipConfig = SipConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sipHeaders = SipHeaders.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = HandoffReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      sipConfig: isSet(object.sipConfig)
        ? SipConfig.fromJSON(object.sipConfig)
        : isSet(object.sip_config)
        ? SipConfig.fromJSON(object.sip_config)
        : undefined,
      sipHeaders: isSet(object.sipHeaders)
        ? SipHeaders.fromJSON(object.sipHeaders)
        : isSet(object.sip_headers)
        ? SipHeaders.fromJSON(object.sip_headers)
        : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : undefined,
      references: isSet(object.references) ? HandoffReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: HandoffUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.sipConfig !== undefined) {
      obj.sipConfig = SipConfig.toJSON(message.sipConfig);
    }
    if (message.sipHeaders !== undefined) {
      obj.sipHeaders = SipHeaders.toJSON(message.sipHeaders);
    }
    if (message.active !== undefined) {
      obj.active = message.active;
    }
    if (message.references !== undefined) {
      obj.references = HandoffReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffUpdate>): HandoffUpdate {
    return HandoffUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffUpdate>): HandoffUpdate {
    const message = createBaseHandoffUpdate();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.sipConfig = (object.sipConfig !== undefined && object.sipConfig !== null)
      ? SipConfig.fromPartial(object.sipConfig)
      : undefined;
    message.sipHeaders = (object.sipHeaders !== undefined && object.sipHeaders !== null)
      ? SipHeaders.fromPartial(object.sipHeaders)
      : undefined;
    message.active = object.active ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? HandoffReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseHandoffSetDefault(): HandoffSetDefault {
  return { id: "" };
}

export const HandoffSetDefault: MessageFns<HandoffSetDefault> = {
  encode(message: HandoffSetDefault, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffSetDefault {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffSetDefault();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffSetDefault {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: HandoffSetDefault): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffSetDefault>): HandoffSetDefault {
    return HandoffSetDefault.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffSetDefault>): HandoffSetDefault {
    const message = createBaseHandoffSetDefault();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseHandoffDelete(): HandoffDelete {
  return { id: "" };
}

export const HandoffDelete: MessageFns<HandoffDelete> = {
  encode(message: HandoffDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: HandoffDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffDelete>): HandoffDelete {
    return HandoffDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffDelete>): HandoffDelete {
    const message = createBaseHandoffDelete();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseHandoffResetHandoffConfigs(): HandoffResetHandoffConfigs {
  return { sipConfig: undefined, sipHeaders: undefined };
}

export const HandoffResetHandoffConfigs: MessageFns<HandoffResetHandoffConfigs> = {
  encode(message: HandoffResetHandoffConfigs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sipConfig !== undefined) {
      SipConfig.encode(message.sipConfig, writer.uint32(10).fork()).join();
    }
    if (message.sipHeaders !== undefined) {
      SipHeaders.encode(message.sipHeaders, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandoffResetHandoffConfigs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandoffResetHandoffConfigs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sipConfig = SipConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sipHeaders = SipHeaders.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandoffResetHandoffConfigs {
    return {
      sipConfig: isSet(object.sipConfig)
        ? SipConfig.fromJSON(object.sipConfig)
        : isSet(object.sip_config)
        ? SipConfig.fromJSON(object.sip_config)
        : undefined,
      sipHeaders: isSet(object.sipHeaders)
        ? SipHeaders.fromJSON(object.sipHeaders)
        : isSet(object.sip_headers)
        ? SipHeaders.fromJSON(object.sip_headers)
        : undefined,
    };
  },

  toJSON(message: HandoffResetHandoffConfigs): unknown {
    const obj: any = {};
    if (message.sipConfig !== undefined) {
      obj.sipConfig = SipConfig.toJSON(message.sipConfig);
    }
    if (message.sipHeaders !== undefined) {
      obj.sipHeaders = SipHeaders.toJSON(message.sipHeaders);
    }
    return obj;
  },

  create(base?: DeepPartial<HandoffResetHandoffConfigs>): HandoffResetHandoffConfigs {
    return HandoffResetHandoffConfigs.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HandoffResetHandoffConfigs>): HandoffResetHandoffConfigs {
    const message = createBaseHandoffResetHandoffConfigs();
    message.sipConfig = (object.sipConfig !== undefined && object.sipConfig !== null)
      ? SipConfig.fromPartial(object.sipConfig)
      : undefined;
    message.sipHeaders = (object.sipHeaders !== undefined && object.sipHeaders !== null)
      ? SipHeaders.fromPartial(object.sipHeaders)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
